module.exports = __webpack_public_path__ + "images/emoji/sparkles.73ac31c4b1a2122a93ad.png";